module.exports = __webpack_public_path__ + "static/media/开源中国@2x.642335eb.png";